export enum Role {
    basic = "Basic",
    admin = "Admin",
    nationalQcAdmin = "NationalQcAdmin",
    icsAccess = "ICSAccess",
}
